import { render, staticRenderFns } from "./premiumTab.vue?vue&type=template&id=38121753&scoped=true&"
import script from "./premiumTab.vue?vue&type=script&lang=js&"
export * from "./premiumTab.vue?vue&type=script&lang=js&"
import style0 from "./premiumTab.vue?vue&type=style&index=0&id=38121753&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38121753",
  null
  
)

export default component.exports